import {createFeatureSelector, createSelector} from "@ngrx/store";
import {
  PrescriptionDetailState
} from "@app/areas/prescriptions/components/prescription-detail/state/prescription-detail.reducer";

export const selectPrescriptionsState = createFeatureSelector<PrescriptionDetailState>('prescriptionDetail');

export const selectAllDoses = createSelector(
  selectPrescriptionsState,
  (state: PrescriptionDetailState) => state.doses
);

export const selectLoadingDoses = (prescriptionId: string) => createSelector(
  selectPrescriptionsState,
  (state: PrescriptionDetailState) => state.dosesUpdating.filter(e => e.prescriptionId === prescriptionId)
);

export const selectPrescriptionDoses = (prescriptionId: string) => createSelector(
  selectPrescriptionsState,
  (state: PrescriptionDetailState) => {
    const loadingMatch = state.doses.loadingFor.filter(e => e === prescriptionId)

    return {
      isLoading: loadingMatch.length > 0,
      doses: state.doses.doses.filter(e => e.prescriptionId === prescriptionId)
    }
  }
);
